import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import BirthdayEvent from '../../assets/birthday-event.png';
import FamilyGathering from '../../assets/family-gathering.png';
import OfficeEvent from '../../assets/office-events.png';
import WeddingFunction from '../../assets/wedding-function.png';
import { pageAction } from '../../redux_files/actions/page_actions';

const OtherBuffetOptions = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Book Your Buffet';
    dispatch(pageAction('Book Your Buffet'));
  }, [dispatch]);

  return (
    <>
      <div className='container'>
        <div className='aboutus outer-border pd-20'>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '24px' }}>
            <button
              className='primary-button'
              style={{ fontSize: '20px', padding: '12px 32px', borderRadius: '8px', fontWeight: 600 }}
              onClick={() => navigate('/buffet-booking')}
            >
              Buffet Options
            </button>
          </div>
          <div className='food-images-grid'>
            {[
              { src: BirthdayEvent, alt: 'Birthday Party Food', label: 'Birthday Party' },
              { src: FamilyGathering, alt: 'Family Gathering Food', label: 'Family Gathering' },
              { src: OfficeEvent, alt: 'Office Buffet Food', label: 'Office Events' },
              { src: WeddingFunction, alt: 'Wedding Function Food', label: 'Wedding Function' },
            ].map(({ src, alt, label }, idx) => (
              <div key={label} className='food-image-block'>
                <img src={src} alt={alt} className='food-image' />
                <div className='food-image-label'>{label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default OtherBuffetOptions;
